import React from 'react';
import { Dialog } from 'primereact/dialog';
import { FormCurveTime } from './FormCurveTime';
import { DeleteCurveTime } from './DeleteCurveTime';
import { Button } from 'reactstrap';


export const DialogCurveTime = (props) => {
    const {
        modal, modalTitle, method, loading, handleInputChange, saveCreate, saveUpdate, saveDelete, validations, time_in_minutes, label, time_valid, label_valid, closeModalCurves
    } = props;




    const dialogTheme = method === "delete"
        ? ` seller-dialog seller-dialog seller-danger seller-small-v`
        : "Global-dialog Global-blue Global-small-v3 ";


    const icon = method === "delete"
        ? <i className="fa fa-trash"></i>
        : <i className="fa fa-clock-o f-20"></i>




    return (
        <Dialog
            visible={modal}
            modal
            onHide={closeModalCurves}
            resizable={false}
            closable={false}
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            {icon}
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {modalTitle}
                            </div>
                        </div>
                    </div>
                </div>
            }
            draggable={false}
            className={` ${dialogTheme}`}
            footer={
                <>
                    {
                        method === "create" && <Button
                            color="secondary"
                            type="submit"
                            size="sm"
                            className={`me-2 ${loading ? "disabled progress-bar-animated progress-bar-striped" : ""}`}
                            disabled={loading}
                            onClick={saveCreate}
                        >
                            {loading ? "Guardando..." : "Guardar"}
                        </Button>
                    }
                    {
                        method === "update" && <Button
                            color="secondary"
                            type="submit"
                            size="sm"
                            className={`me-2 ${loading ? "disabled progress-bar-animated progress-bar-striped" : ""}`}
                            disabled={loading}
                            onClick={saveUpdate}
                        >
                            {loading ? "Actualizando..." : "Actualizar"}
                        </Button>
                    }
                    {
                        method === "delete" && <Button
                            color="secondary"
                            type="submit"
                            size="sm"
                            className={`me-2 ${loading ? "disabled progress-bar-animated progress-bar-striped" : ""}`}
                            disabled={loading}
                            onClick={saveDelete}
                        >
                            {loading ? "Eliminando..." : "Eliminar"}
                        </Button>
                    }
                    <Button
                        size="sm"
                        color="danger"
                        type="button"
                        onClick={closeModalCurves}
                    >
                        Cancelar
                    </Button>
                </>
            }
        >
            {method === "create" ? (
                <FormCurveTime
                    button="Crear"
                    {...{
                        modal, closeModalCurves, modalTitle, method, loading, handleInputChange, validations, time_in_minutes, label, time_valid, label_valid,

                        methodAction: saveCreate
                    }}
                />
            ) : method === "update" ? (
                <FormCurveTime
                    button="Actualizar Tiempo"
                    {...{
                        modal, closeModalCurves, modalTitle, method, loading, handleInputChange, validations, time_in_minutes, label, time_valid, label_valid,
                        methodAction: saveUpdate
                    }}
                />
            ) : (
                <DeleteCurveTime
                    {...{ closeModalCurves, loading, label, time_in_minutes, saveDelete }}
                />
            )}
        </Dialog>
    );
};
